export const SALESWARRANTY_LOADING = "SALESWARRANTY_LOADING";
export const SALESWARRANTY_RESET = "SALESWARRANTY_RESET";
export const GET_SALESWARRANTY = "GET_SALESWARRANTY";
export const GET_SALESWARRANTY_SUCCESS = "GET_SALESWARRANTY_SUCCESS";
export const GET_SALESWARRANTY_FAIL = "GET_SALESWARRANTY_FAIL";
export const DELETE_SALESWARRANTY = "DELETE_SALESWARRANTY"
export const DELETE_SALESWARRANTY_SUCCESS = "DELETE_SALESWARRANTY_SUCCESS"
export const DELETE_SALESWARRANTY_FAIL = "DELETE_SALESWARRANTY_FAIL"
export const UPDATE_SALESWARRANTY = "UPDATE_SALESWARRANTY"
export const UPDATE_SALESWARRANTY_SUCCESS = "UPDATE_SALESWARRANTY_SUCCESS"
export const UPDATE_SALESWARRANTY_FAIL = "UPDATE_SALESWARRANTY_FAIL"
export const ADD_NEW_SALESWARRANTY = "ADD_NEW_SALESWARRANTY"
export const ADD_SALESWARRANTY_SUCCESS = "ADD_SALESWARRANTY_SUCCESS"
export const ADD_SALESWARRANTY_FAIL = "ADD_SALESWARRANTY_FAIL"